export default "__VITE_ASSET__CnxsWYo1__"